<template>
  <v-container fluid class="custom-container-details">
    <div>
      <v-row wrap no-gutters>
        <v-col
          cols="12"
        >
          <v-card class="pa-1 custom-bg rounded-lg">
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-row wrap no-gutters justify="space-between" class="pb-4">
                <v-col
                  cols="12"
                  class="pr-sm-1"
                >
                  <v-text-field
                    v-model="role.name"
                    outlined
                    dense
                    :label="$lang.labels.name"
                    :hint="formatHint"
                    :persistent-hint="isEdit"
                    required
                    class="required-asterisk"
                    :rules="[
                      v => !!v.trim() || $lang.errors.required,
                      v => (v.trim().length > 1 && v.trim().length <= 250) || $lang.errors.nameTooShortOrLong
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-col v-if="isEdit" cols="12" class="mb-4">
                <v-divider></v-divider>
              </v-col>
              <v-row no-gutters wrap justify="space-between">
                <v-col
                  cols="6"
                  class="text-left"
                >

                  <div class="d-inline-flex align-center">
                    <v-btn
                      outlined

                      color="primary"
                      :to="{ name: 'roles', params: { lang: $lang.current_lang } }"
                    >
                      <v-icon
                        right
                        dark
                        class="ma-0"
                      >
                        mdi-arrow-left
                      </v-icon>
                      <span class="ml-1">{{ $lang.actions.back }}</span>
                    </v-btn>
                    <action-button-with-confirmation
                      v-if="isEdit"
                      outlined
                      :action-text="$lang.actions.areYouSureYouWantToDelete"
                      :action-text-suffix="role.name"
                      :title="$lang.actions.delete"
                      type="role"
                      :is-disabled="!userCanDelete"
                      :button-text="$lang.actions.delete"
                      :button-color="'error'"
                      :data-cy="'role-delete'"
                      :forced-option="true"
                      :trigger-force-logic="triggerForceLogic"
                      class="ml-2"
                      :regular-delete-errors-usages="regularDeleteErrorsUsages"
                      :regular-delete-errors-resources="regularDeleteErrorsResources"
                      :regular-delete-errors-users="regularDeleteErrorsUsers"
                      :delete-success="deleteSuccess"
                      @submit="deleteRoleFunct($event)"
                      @closeAfterDelete="$router.push({ name: 'roles' })"
                      @closeDialog="''"
                    />
                  </div>
                </v-col>
                <v-col
                  cols="6"
                  class="text-right"
                >
                  <v-btn
                    outlined
                    :disabled="!valid || lock || !isEdit"
                    color="primary"
                    class="mr-2  color-accent-text"
                    @click="copyCreateResource(role, 'roleCreate', $router, '', $options.filters.formatDateTime(new Date()))"
                  >
                    <v-icon
                      left
                      dark
                    >
                      mdi-content-copy
                    </v-icon>
                    {{ $lang.actions.copyCreate }}
                  </v-btn>
                  <v-btn
                    :disabled="!isFormValid"
                    color="primary"

                    @click="submit()"
                  >
                    <v-icon
                      left
                      dark
                      class="mr-1"
                    >
                      mdi mdi-floppy
                    </v-icon>
                    {{ $lang.actions.submit }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <multi-errors-snackbar
      :show="showSnackErrors"
      :errors="errorsForSnackbar"
      @close="showSnackErrors = false; errorsForSnackbar = []"
    />
  </v-container>
</template>

<script>
import {
  createRoleUsingPOST as createRole, deleteRoleUsingDELETE as deleteRole,
  getRoleByIdUsingGET as getRole, updateRoleUsingPUT as updateRole
} from '@/utils/api'
import ActionButtonWithConfirmation from '@/components/ui/ActionButtonWithConfirmation.vue'
import MultiErrorsSnackbar from '@/components/ui/MultiErrorsSnackbar.vue'
import { mapActions } from 'vuex'
import { copyCreateResource } from '@/utils/helpers'
import { bus } from '@/main'

export default {
  components: { ActionButtonWithConfirmation, MultiErrorsSnackbar },
  data() {
    return {
      err: '',
      errorsForSnackbar: [],
      showSnackErrors: false,
      success: '',
      valid: false,
      loading: false,
      lock: false,
      role: {
        id: '',
        name: '',
        isAssignableToUsers: false,
        isSystem: false,
        createdOn: '',
        modifiedOn: ''
      },
      isSuperUser: false,
      userCanDelete: false,
      triggerForceLogic: false,
      regularDeleteErrorsUsages: [],
      deleteSuccess: false,
      isEdit: false,
      regularDeleteErrorsResources: [],
      regularDeleteErrorsUsers: []
    }
  },
  computed: {
    formatHint() {
      return `${this.$lang.labels.createdOn}: ${this.$options.filters.formatDateTime(this.role.createdOn)}, ${this.$lang.labels.modifiedOn}: ${this.$options.filters.formatDateTime(this.role.modifiedOn)}, ID: ${this.role.id}`
    },
    isFormValid() {
      return this.valid && !this.lock
    }
  },
  watch: {
    isFormValid(val) {
      this.formValid(val)
    }
  },
  mounted() {
    bus.$on('saveResource', this.submit)
  },
  beforeDestroy() {
    bus.$off('saveResource', this.submit)
  },
  created() {
    this.isEdit = this.$route.name === 'roleEdit'

    let user = null

    if (localStorage.userData) {
      user = JSON.parse(localStorage.userData)

      this.isSuperUser = !!user.roles.find((x) => x.name === 'SUPER_USER')
      this.userCanDelete = !!user.roles.find((x) => x.name === 'ROLE_DELETER') || this.isSuperUser
    }
    if (this.isEdit && this.$route.params.id) {
      this.loading = true
      getRole({ id: this.$route.params.id })
        .then((res) => {
          this.role = res.data.data

          this.loading = false
        })
        .catch((err) => {
          this.addSnackbar({
            message: err,
            timeout: 5000,
            color: 'error'
          })
          this.loading = false
        })
    } else {
      if (this.$route.params.copy) {
        this.role = this.$route.params.copy
        this.loading = false
      } else {
        this.loading = false
      }
    }
  },
  methods: {
    ...mapActions('app', ['addSnackbar', 'formValid']),
    copyCreateResource,
    deleteRoleFunct(isForced = false) {
      this.triggerForceLogic = false
      this.regularDeleteErrorsUsages = []
      this.deleteSuccess = false
      deleteRole({ id: this.role.id, force: isForced })
        .then((res) => {
          if (res.status === 200) {
            this.deleteSuccess = true
            this.regularDeleteErrorsUsages = res.data.data.usages
          } else {
            this.triggerForceLogic = true
            this.regularDeleteErrorsUsages = res.response.data.data.usages
            this.regularDeleteErrorsResources = res.response.data.data.relatedResources
            this.regularDeleteErrorsUsers = res.response.data.data.relatedUsers
          }
        })
        .catch((err) => {
          this.addSnackbar({
            message: err,
            timeout: 5000,
            color: 'error'
          })        })
    },
    async submit() {
      this.lock = true

      let res = null

      try {

        res = this.isEdit ? await updateRole({ id: this.role.id, body: { name: this.role.name } }) : await createRole({ body: this.role })

        if (res && res.status !== 200) {
          if (res?.response?.data?.data?.[0]?.error) {

            res?.response?.data?.data?.forEach((error) => {
              this.errorsForSnackbar.push({
                text: error.error,
                value: null
              })
            })
            this.showSnackErrors = true
          } else {
            const errorMessage = res?.response?.data?.statusText || (this.isEdit ? this.$lang.errors.roleUpdate : this.$lang.errors.roleCreate)

            this.addSnackbar({
              message: errorMessage,
              timeout: 5000,
              color: 'error'
            })
          }
          this.lock = false

          return
        }
        const successMessage = this.isEdit ? this.$lang.success.roleUpdated : this.$lang.success.roleCreated

        this.addSnackbar({
          message: successMessage,
          timeout: 5000,
          color: 'success'
        })
        this.$router.push({
          name: 'roles',
          params: {
            message: successMessage
          }
        })

      } catch (err) {
        this.addSnackbar({
          message: err,
          timeout: 5000,
          color: 'error'
        })
        this.lock = false
      }
    }
  }
}
</script>
